module.exports = __webpack_public_path__ + "static/media/icon-compliance-white.3da563a6.svg";